// @flow
import GroupLayout, { groupLayoutTester } from './GroupLayout';
import VerticalLayout, { verticalLayoutTester } from './VerticalLayout';
import VerticalTabLayout, {
    verticalTabLayoutTester
} from './VerticalTabLayout';
import TabLayout, { tabLayoutTester } from './TabLayout';
import HorizontalLayoutRenderer, {
    horizontalLayoutTester
} from './HorizontalLayout';
import CardLayout, { cardLayoutTester } from './CardLayout';
import BooleanGroupLayout, {
    booleanGroupLayoutTester
} from './BooleanGroupLayout';
import SetDefaultVAEConfigLayout, {
    setDefaultVAEConfigLayoutTester
} from './SetDefaultVAEConfigLayout';
import VAEConfigurationLayout, {
    vaeConfigurationLayoutTester
} from './VAEConfigurationLayout';
import DomainManagementLayout, {
    domainManagementLayoutTester
} from './DomainManagementLayout';
import RenewClientExpiryLayout, {
    renewClientExpiryTester
} from './RenewClientExpiryLayout';
import StatusChangeLayout, {
    statusChangeLayoutTester
} from './StatusChangeLayout';
import StageChangeLayout, {
    stageChangeLayoutTester
} from './StageChangeLayout';
import PregenSeriesLayout, {
    pregenSeriesLayoutTester
} from 'platform/settings/modules/orchestration/layouts/PregenSeriesLayout';
import ServiceabilityLayout, {
    serviceabilityLayoutTester
} from 'platform/settings/modules/orchestration/layouts/ServiceabilityLayout';
import RuleConfigurationLayout, {
    ruleConfigurationLayoutTester
} from 'platform/settings/modules/orchestration/layouts/RuleConfigurationLayout';

const renderers = [
    { renderer: GroupLayout, tester: groupLayoutTester },
    { renderer: VerticalLayout, tester: verticalLayoutTester },

    { renderer: TabLayout, tester: tabLayoutTester },
    { renderer: VerticalTabLayout, tester: verticalTabLayoutTester },
    { renderer: HorizontalLayoutRenderer, tester: horizontalLayoutTester },
    { renderer: CardLayout, tester: cardLayoutTester },
    { renderer: BooleanGroupLayout, tester: booleanGroupLayoutTester },
    {
        renderer: SetDefaultVAEConfigLayout,
        tester: setDefaultVAEConfigLayoutTester
    },
    { renderer: VAEConfigurationLayout, tester: vaeConfigurationLayoutTester },
    { renderer: DomainManagementLayout, tester: domainManagementLayoutTester },
    { renderer: RenewClientExpiryLayout, tester: renewClientExpiryTester },
    { renderer: StatusChangeLayout, tester: statusChangeLayoutTester },
    { renderer: StageChangeLayout, tester: stageChangeLayoutTester },
    { renderer: PregenSeriesLayout, tester: pregenSeriesLayoutTester },
    { renderer: ServiceabilityLayout, tester: serviceabilityLayoutTester },
    {
        renderer: RuleConfigurationLayout,
        tester: ruleConfigurationLayoutTester
    }
];

export default renderers;
